import { ReactElement, useEffect, useState } from "react";
import { Button, Card, Col, Skeleton, Image, Avatar } from "antd";
import { useTranslation } from "react-i18next";
import { FacebookOutlined, TwitterOutlined, LinkedinOutlined, InstagramOutlined, ShopOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { getAuthState } from "../../redux/selectors";

export const BranchCard = (props: any): ReactElement => {
  const { branch, onBook, onRequestAccess, club } = props;
  const { t } = useTranslation();
  const [loading, setLoading] = useState<boolean>(false)
  const { currentUser } = useSelector(getAuthState);
  const history = useHistory();

  const enterClubShop = (clubName: any) => {
    history.push(`/shop/club/${clubName}`);
  }

  const renderButtons = () => {
    if (club.status === "available") return <Button type="primary" loading={loading} onClick={() => onBook(branch, club)}>{t("court.book_now")}</Button>;
    if (club.status === "coming_soon" && currentUser === undefined) return <Button type="primary" loading={loading} onClick={() => history.push("/login")}>{t("club.notify_me")}</Button>
    if (club.status === "request_access") {
      if (currentUser === undefined) {
        return <Button type="primary" loading={loading} onClick={() => history.push("/login")}>{t("auth.login_to_book")}</Button>
      }
      const priorities = club.priority ? club.priority : [];
      if (priorities.findIndex((p: string) => p === currentUser?.id) > -1) {
        return <Button className="club-for-users-table-action-button" onClick={() => onBook(branch, club)}>{t("court.book_now")}</Button>
      }
      return <Button className="club-for-users-table-action-button" onClick={onRequestAccess}>{t("club.request_access")}</Button>
    }
    return null;
  }

  return (
    <Col xs={24} sm={12} md={8} lg={8} xl={6} key={branch.branchId}>
      <Card
        className="court-card"
        actions={[
          <div className="social-link-list">
            {club?.facebook && (
              <Button
                icon={<FacebookOutlined />}
                shape="circle"
                href={club.facebook}
                target="_blank"
              />
            )}
            {club?.twitter && (
              <Button
                icon={<TwitterOutlined />}
                shape="circle"
                href={club.twitter}
                target="_blank"
              />
            )}
            {club?.linkedIn && (
              <Button
                icon={<LinkedinOutlined />}
                shape="circle"
                href={club.linkedIn}
                target="_blank"
              />
            )}
            {club?.instagram && (
              <Button
                icon={<InstagramOutlined />}
                shape="circle"
                href={club.instagram}
                target="_blank"
              />
            )}
            {/* <Button
                icon={<ShopOutlined />}
                shape="circle"
                onClick={()=>enterClubShop(club.firestoreRef)}
                target="_blank"
              /> */}
          </div>,
          <div>
            {renderButtons()}
          </div>
        ]}
      >
        <Skeleton active loading={loading}>
          <Image
            src={branch.photo} height={150} width="100%" style={{ objectFit: "cover" }}
            fallback="data:image/png;base64,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"
          />
          <h2 className="court-title">
            <span>
              <Avatar src={club?.photo} shape="circle" size={36} />
              <span style={{ marginLeft: 5, fontSize: 18 }}>{club?.name}, {branch.location}</span>
            </span>
          </h2>
          <div className="court-count">
            {t("branch.indoor_courts")}:
            <span>{`${branch.indoorCourts} courts`}</span>
          </div>
          <div className="court-count">
            {t("branch.outdoor_courts")}:
            <span>{`${branch.outdoorCourts} courts`}</span>
          </div>
          <div className="court-count">
            {t("branch.location")}:
            <span>
              {club.status === "coming_soon" ? branch.location : <a href={branch.location} target="_blank" rel="noreferrer">
                {branch.location}
              </a>
              }
            </span>
          </div>
          <div className="court-hours">
            {t("branch.working_hours")}:
            <span>{`${moment(`2021-01-01T${branch.startTime}`).format("h:mm A")} - ${moment(`2021-01-01T${branch.endTime}`).format("h:mm A")}`}</span>
          </div>
          {club.status === "coming_soon" &&
            <div>
              <h3 style={{ marginTop: 20, textAlign: "center", fontWeight: 700, fontSize: 24 }}>{currentUser ? t("club.coming_soon") : t("club.almost_there")}</h3>
              <p style={{ textAlign: "center", fontWeight: 700 }}> {currentUser ? t("club.coming_soon_notification") : t("club.coming_soon_notification_without_login")}</p>
            </div>
          }
        </Skeleton>
      </Card>
    </Col>
  );
};
